const dat=[
    {
        "srcImg": require('./essentials/img/1.jpg'),
        "cardName": "Alloy Wheel",
        "priceBefore": "Rs. 6000",
        "priceAfter": "Rs.4000"
    },
    {
        "srcImg": require('./essentials/img/2.jpg'),
        "cardName": "Disk Brakes",
        "priceBefore": "Rs. 6000",
        "priceAfter": "Rs.2500"
    },
    {
        "srcImg": require('./essentials/img/4.jpg'),
        "cardName": "Headlights",
        "priceBefore": "Rs. 6000",
        "priceAfter": "Rs.3000"
    }
    
]

export default dat;